import * as React from 'react'

function SvgIconCd(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="cd" aria-labelledby="t-cd d-cd">
        <title id="t-cd">{'CD'}</title>
        <desc id="d-cd">{'Compact Disc'}</desc>
        <path d="M16 1c8.3 0 15 6.7 15 15s-6.7 15-15 15S1 24.3 1 16 7.7 1 16 1m0-1C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z" />
        <path d="M16 14c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-1c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM6 10.8c-.1 0-.2 0-.2-.1-.2-.1-.3-.4-.2-.7C7.7 6.3 11.7 4 16 4c.3 0 .5.2.5.5s-.2.5-.5.5c-3.9 0-7.6 2.1-9.5 5.5-.1.2-.3.3-.5.3zM16 28c-.3 0-.5-.2-.5-.5s.2-.5.5-.5c3.9 0 7.6-2.1 9.5-5.5.1-.2.4-.3.7-.2.2.101.3.4.2.7-2.1 3.7-6.1 6-10.4 6z" />
      </g>
    </svg>
  )
}

export default SvgIconCd
